const terminListErrorStatus = {
  loading: false,
  finished: true,
  responseCode: 404,
  failed: true,
  generalErrors: [
    { message: 'Akcia neúspešná. Filtrovacie kritériá nespĺňa žiadny záznam.' }],
  fieldErrors: [],
};

const technickePricinyErrorStatus = {
  loading: false,
  finished: true,
  responseCode: 404,
  failed: true,
  generalErrors: [
    {
      message: 'Nepodarilo sa vykonať akciu. Prosím, zopakujte požiadavku neskôr alebo kontaktujte'
        + ' Helpdesk Slov-Lex.',
    }],
  fieldErrors: [],
};

export { terminListErrorStatus, technickePricinyErrorStatus };
